import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import logo from '../../assets/logo.svg';

const navItems = [
  { section: 'PRACTICE', subtitle: 'Human2Agent' },
  { label: 'Start Practice', path: '/practice', icon: '🎙' },
  { label: 'Practice History', path: '/practice/history', icon: '📋' },
  { section: 'LAB', subtitle: 'Agent2Agent' },
  { label: 'Dashboard', path: '/dashboard', icon: '📊' },
  { label: 'My Agents', path: '/agents', icon: '🤖' },
  { label: 'My Scenarios', path: '/scenarios', icon: '📝' },
  { label: 'V2V Simulations', path: '/simulations', icon: '▶' },
  { label: 'Analytics', path: '/analytics', icon: '📈' },
  { label: 'Benchmark', path: '/benchmark', icon: '⚖' },
  { label: 'Corpus', path: '/corpus', icon: '🗄' },
  { label: 'Developer', path: '/developer', icon: '🔑' },
];

export default function Sidebar({ open, isMobile, onClose }) {
  const location = useLocation();
  const navigate = useNavigate();

  const sidebarStyle = {
    width: '220px',
    backgroundColor: '#fff',
    borderRight: '1px solid #e5e7eb',
    position: 'fixed',
    top: isMobile ? 0 : '60px',
    left: 0,
    bottom: 0,
    padding: isMobile ? '0' : '24px 0',
    overflowY: 'auto',
    zIndex: 99,
    transform: open ? 'translateX(0)' : 'translateX(-100%)',
    transition: 'transform 0.3s ease',
    boxShadow: isMobile && open ? '4px 0 20px rgba(0,0,0,0.15)' : 'none',
  };

  function handleNavigate(path) {
    navigate(path);
    if (isMobile) onClose();
  }

  return (
    <aside style={sidebarStyle}>
      {/* Mobile header with logo as close/toggle */}
      {isMobile && (
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '16px 20px', borderBottom: '1px solid #e5e7eb',
          backgroundColor: '#fff', height: '60px', boxSizing: 'border-box',
        }}>
          <img
            src={logo}
            alt="V2VLab"
            style={{ height: '28px', cursor: 'pointer' }}
            onClick={() => handleNavigate('/dashboard')}
          />
          <button
            onClick={onClose}
            style={{
              background: 'none', border: 'none', cursor: 'pointer',
              fontSize: '20px', color: '#6b7280', padding: '4px',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}
          >
            ✕
          </button>
        </div>
      )}

      {/* Nav items */}
      <div style={{ padding: isMobile ? '16px 0' : '0 16px' }}>
        {navItems.map((item, idx) => {
          if (item.section) {
            return (
              <div key={idx} style={{
                padding: isMobile ? '12px 24px 6px' : '0 8px',
                marginBottom: '4px', marginTop: idx === 0 ? '0' : '16px',
              }}>
                <div style={{
                  fontSize: '13px', fontWeight: '800', color: '#374151',
                  letterSpacing: '0.8px', textTransform: 'uppercase',
                }}>
                  {item.section}
                </div>
                {item.subtitle && (
                  <div style={{
                    fontSize: '11px', fontWeight: '600', color: '#9ca3af',
                    letterSpacing: '0.3px', marginTop: '1px',
                  }}>
                    {item.subtitle}
                  </div>
                )}
              </div>
            );
          }

          const isActive = location.pathname === item.path ||
            (item.path !== '/dashboard' && item.path !== '/practice' &&
              location.pathname.startsWith(item.path));

          return (
            <div
              key={item.path}
              style={{
                display: 'flex', alignItems: 'center', gap: '10px',
                padding: isMobile ? '13px 24px' : '9px 12px',
                borderRadius: isMobile ? '0' : '8px',
                cursor: 'pointer', fontSize: '15px', fontWeight: '500',
                color: isActive ? '#0052CC' : '#111827',
                backgroundColor: isActive ? '#EBF5FF' : 'transparent',
                marginBottom: isMobile ? '0' : '2px',
                borderLeft: isMobile && isActive ? '3px solid #0052CC' : isMobile ? '3px solid transparent' : 'none',
                transition: 'all 0.15s',
              }}
              onClick={() => handleNavigate(item.path)}
            >
              <span style={{ fontSize: '16px', width: '20px', textAlign: 'center' }}>
                {item.icon}
              </span>
              {item.label}
            </div>
          );
        })}
      </div>
    </aside>
  );
}
